
/*import Vue from 'vue'*/
import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV)


Vue.use(Router)

import Layout from '../views/layout/index.vue';
import UserLayout from '../views/layout/userIndex.vue';

export default new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/index',
      hidden: true,
			children: [
				{
					path: '/index',
					name: 'index',
					hidden: true,
					component: _import('index'),
					meta: { icon: 'dashboard' }
				},
				{
					path: '/about',
					name: 'about',
					hidden: true,
					component: _import('about'),
					meta: { }
				},
				{
					path: '/login',
					name: 'login',
					hidden: true,
					component: _import('login'),
					meta: {  }
				},
				{
					path: '/news',
					name: 'news',
					hidden: true,
					component: _import('news'),
					meta: {  }
				},
				{
					path: '/new_detail/:id',
					name: 'new_detail',
					hidden: true,
					component: _import('new_detail'),
					meta: {  }
				},
				{
					path: '/register',
					name: 'register',
					hidden: true,
					component: _import('register'),
					meta: {  }
				},

				],
    },
		{
			path:'/user',
			component:UserLayout,
			redirect:'/user/index',
			hidden:true,
			children:[
				{
					path: '/user/index',
					name: 'user_index',
					hidden: true,
					component: _import('user/index'),
					meta: { icon: 'dashboard' }
				},
				{
					path: '/user/pre_waybill/create',
					name: 'user_pre_waybill_create',
					hidden: true,
					component: _import('user/pre_waybill/publish'),
					meta: { icon: 'dashboard',title:"单件包裹录入" }
				},
				{
					path: '/user/pre_waybill/batchImport',
					name: 'user_pre_waybill_batchImport',
					hidden: true,
					component: _import('user/pre_waybill/batchImport'),
					meta: { icon: 'dashboard',title:"批量包裹导入" }
				},

        {
          path: '/user/pre_waybill/modify/:id',
          name: 'user_pre_waybill_modify',
          hidden: true,
          component: _import('user/pre_waybill/publish'),
          meta: { icon: 'dashboard',title:"预录单修改"  }
        },
				{
					path: '/user/pre_waybill/list',
					name: 'user_pre_waybill_list',
					hidden: true,
					component: _import('user/pre_waybill/list'),
					meta: { icon: 'dashboard',title:'预录单管理' }
				},
				{
					path: '/user/waybill/list',
					name: 'user_waybill_list',
					hidden: true,
					component: _import('user/waybill/list'),
					meta: { icon: 'dashboard',title:'包裹管理' }
				},
				{
					path: '/user/receiver/index',
					name: 'user_receiver_index',
					hidden: true,
					component: _import('user/receiver/index'),
					meta: { icon: 'dashboard' ,title:'收件人库'}
				},
				{
					path: '/user/sender/index',
					name: 'user_sender_index',
					hidden: true,
					component: _import('user/sender/index'),
					meta: { icon: 'dashboard' ,title:'发件人库'}
				},
				{
					path: '/user/idcard/index',
					name: 'user_idcard_index',
					hidden: true,
					component: _import('user/idcard/index'),
					meta: { icon: 'dashboard' ,title:'身份证上传'}
				},
				{
					path: '/user/reset',
					name: 'user_reset',
					hidden: true,
					component: _import('user/reset'),
					meta: { icon: 'dashboard' ,title:'更改密码'}
				},
			]
		},

    { path: '*', redirect: '/404', hidden: true }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js